export const ROW_JUSTIFY = 'center'
export const COL_SPAN = 18
export const ENTER_ORG_TYPE = {
  CREATE: 1,
  JOINCODE: 2,
}

export const SESSION_STORAGE_INVITE_CODE = 'felo_invite_code'

export const LOCAL_LANG = {
  'en-US': 'en',
  'ja-JP': 'ja',
  'zh-TW': 'zh-hant',
  'zh-CN': 'zh-hans',
}

export const ROUTER_BASENAME = 'signin'

export const FELO_IM_URL =
  window.location.href.indexOf('https://account.felo.me/') != -1
    ? 'https://im.felo.me'
    : 'https://im-dev.felo.me'

export const AvatarColorsArr = [
  '#C6B858',
  '#A96C6C',
  '#6C78A9',
  '#A06CA9',
  '#DD8A62',
  '#67A6D2',
  '#72CADC',
  '#79C69A',
  '#6C9AA9',
  '#8CA96C',
]

const URL_ORI =
  window.location.origin.indexOf('account.felo.me') != -1
    ? window.location.origin
    : 'https://api.sandbox.felo.me'

export const SNS_CALLBACK_URL = {
  GITHUB: URL_ORI + '/sns/oauth2/github/login',
  FACEBOOK: URL_ORI + '/sns/oauth2/facebook/login',
  TWITTER: URL_ORI + '/sns/oauth2/twitter/login',
  GOOGLE: URL_ORI + '/sns/oauth2/google/login',
}

export const EMAIL_ACTION_TYPE = {
  REGISTER: 'register',
  FINDPWD: 'findpwd',
}
